export function Feedback () {
  return (
    <div>
      <h1>Feedback</h1>
    </div>
  );
}